import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import SpinnerComponent from "../../../../../../Components/Loding/Spinner";
import Table from "../../../../../../Components/Table";
import {
    CadastrarFiltroAcaoEtapaController,
    DeletarFiltroAcaoEtapaController,
    ListarFiltrosAcaoEtapaController,
    ListarTipoFiltroAcaoEtapaController,
} from "../../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import {
    IReguaEtapaAcaoFiltro,
    IReguaEtapaAcaoTipoFiltro,
} from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
interface IProps {
    idAcaoEtapa: number;
}

interface IFormData {
    ID_TIPO_FILTRO: number;
    DS_OPERADOR: string;
    DS_VALOR: string;
}

export default function ModalGerenciarFiltroAcao(props: IProps) {
    const [LstEtapaAcaoFiltro, setLstEtapaAcaoFiltro] =
        useState<Array<IReguaEtapaAcaoFiltro>>();
    const [LstEtapaAcaoTipoFiltro, setLstEtapaAcaoTipoFiltro] =
        useState<Array<IReguaEtapaAcaoTipoFiltro>>();
    const { register, handleSubmit, formState } = useForm();

    const updateList = useCallback(() => {
        ListarFiltrosAcaoEtapaController(props.idAcaoEtapa).then((res) => {
            setLstEtapaAcaoFiltro(res);
        });
        ListarTipoFiltroAcaoEtapaController().then((res) => {
            setLstEtapaAcaoTipoFiltro(res);
        });
    }, [props.idAcaoEtapa]);

    useEffect(() => {
        updateList();
    }, [updateList]);

    function handleFormSubmit(formData: IFormData) {
        CadastrarFiltroAcaoEtapaController({
            ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO:
                formData.ID_TIPO_FILTRO,
            DS_OPERACAO: formData.DS_OPERADOR,
            DS_VALOR: formData.DS_VALOR,
            ID_CASO_COBRANCA_REGUA_ETAPA_ACAO: props.idAcaoEtapa,
        }).then(() => {
            updateList();
        });
    }

    const rowTipoFiltro = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return <div>{row.DS_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO}</div>;
    };

    const rowOperador = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return <div>{row.DS_OPERACAO}</div>;
    };
    const rowValor = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return (
            <OverlayTrigger
                overlay={
                    row.DS_VALOR.length > 80 ? (
                        <Tooltip id="tooltip-disabled">{row.DS_VALOR}</Tooltip>
                    ) : (
                        <div></div>
                    )
                }
            >
                <div>
                    {row.DS_VALOR.length > 40
                        ? row.DS_VALOR.substring(0, 80) + "..."
                        : row.DS_VALOR}
                </div>
            </OverlayTrigger>
        );
    };

    const rowExcluir = (cell: any, row: IReguaEtapaAcaoFiltro) => {
        return (
            <div className="d-flex justify-content-center align-itens-center">
                <button
                    className="btn  btn-sm btn-outline-danger font-weight-bold"
                    onClick={() => {
                        Swal.fire({
                            title: "Deseja apagar este filtro?",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText:
                                "<i class='la la-check'></i> Sim!",
                            showCancelButton: true,
                            cancelButtonText:
                                "<i class='la la-thumbs-down'></i> Não",
                            customClass: {
                                confirmButton: "btn btn-outline-success",
                                cancelButton: "btn btn-default",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO &&
                                    DeletarFiltroAcaoEtapaController(
                                        row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO
                                    ).then(() => updateList());
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Tipo Filtro",
            formatter: rowTipoFiltro,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Operação",
            formatter: rowOperador,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Valor",
            formatter: rowValor,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO",
            text: "Excluir",
            formatter: rowExcluir,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
    ];

    return LstEtapaAcaoTipoFiltro ? (
        <div>
            <form onSubmit={handleSubmit(handleFormSubmit)} className="mb-3">
                <div className="d-flex flew-wrap col-md-12">
                    <div className="mt-2 p-1 col-md-4">
                        <h6>Tipo Filtro:</h6>
                        <select
                            name="ID_TIPO_FILTRO"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.ID_TIPO_FILTRO && "is-invalid"
                            }`}
                            ref={register({
                                required: "Insira o valor",
                                valueAsNumber: true,
                            })}
                        >
                            <option></option>
                            {LstEtapaAcaoTipoFiltro &&
                                LstEtapaAcaoTipoFiltro.map((TipoFiltro) => {
                                    return (
                                        <option
                                            key={
                                                TipoFiltro.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO
                                            }
                                            value={
                                                TipoFiltro.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO
                                            }
                                        >
                                            {
                                                TipoFiltro.DS_CASO_COBRANCA_REGUA_ETAPA_ACAO_TIPO_FILTRO
                                            }
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                    <div className="mt-2 p-1 col-md-4">
                        <h6>Operação:</h6>
                        <select
                            name="DS_OPERADOR"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.DS_OPERADOR && "is-invalid"
                            }`}
                            ref={register({
                                required: "Insira o valor",
                            })}
                        >
                            <option></option>
                            <option value={"AND"}>AND</option>
                            <option value={"OR"}>OR</option>
                            <option value={"="}>=</option>
                            <option value={"LIKE"}>LIKE</option>
                            <option value={"NOT LIKE"}>NOT LIKE</option>
                            <option value={"IN"}>IN</option>
                            <option value={"NOT IN"}>NOT IN</option>
                            <option value={"<"}>{"<"}</option>
                            <option value={">"}>{">"}</option>
                            <option value={"<>"}>{"<>"}</option>
                            <option value={"<="}>{"<="}</option>
                            <option value={">="}>{">="}</option>
                        </select>
                    </div>
                    <div className="mt-2 p-1 col-md-4">
                        <h6>Valor:</h6>
                        <input
                            type="text"
                            name="DS_VALOR"
                            className={`form-control placeholder-dark-45 ${
                                formState.errors.DS_VALOR && "is-invalid"
                            }`}
                            placeholder="Valor"
                            ref={register({
                                required: "Insira o valor",
                            })}
                        />
                    </div>
                </div>
                <div className="d-flex flew-column justify-content-end m-2">
                    <div className="d-flex flex-column justify-content-end mr-4">
                        <button className="btn btn-outline-success font-weight-bold d-flex justify-content-center align-items-center">
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-1"
                            />{" "}
                            Cadastrar
                        </button>
                    </div>
                </div>
            </form>
            <div className="card card-custom w-auto gutter-b m-5">
                {LstEtapaAcaoFiltro && (
                    <Table
                        columns={columns}
                        data={LstEtapaAcaoFiltro}
                        keyField={"ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_FILTRO"}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhum filtro encontrado
                            </div>
                        )}
                        noSearch
                    />
                )}
            </div>
        </div>
    ) : (
        <SpinnerComponent />
    );
}
